<form
	#editForm="ngForm"
	[formReset]="editForm"
	(ngSubmit)="editForm.valid && submit()">
	<div class="modal-header">
		<h4
			class="modal-title"
			*ngIf="!loading">
			{{'labels.' + title | translate}}
		</h4>
	</div>
	<div
		class="modal-body"
		ngbAutofocus>
		<div
			class="row"
			*ngIf="loading">
			<div class="col text-center">
				<app-loader [material]="false"></app-loader>
			</div>
		</div>

		<div
			class="row"
			*ngIf="!loading && employee">
			<div class="col-sm-12">
				<div class="row">
					<!-- type -->
					<div class="form-group col-md-6">
						<label>{{'labels.type' | translate}}*</label>
						<select
							class="form-control custom-select"
							[(ngModel)]="employee.etype"
							required
							#type="ngModel"
							name="type"
							[ngClass]="{'is-invalid': editForm.submitted && type.invalid}"
							(change)="resetFields()">
							<option
								*ngFor="let t of types"
								[value]="t">
								{{'labels.' + t | translate}}
							</option>
						</select>
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && type.invalid"
							style="display: block;">
							{{'errors.required' | translate}}
						</div>
					</div>
					<!-- joindate -->
					<div class="form-group col-md-6">
						<label>{{'labels.joindate' | translate}}*</label>
						<app-datepicker
							[(ngModel)]="employee.joindate"
							name="joindate"
							required
							#joindate="ngModel"
							[ngClass]="{'is-invalid': editForm.submitted && joindate.invalid}">
						</app-datepicker>
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && joindate.invalid"
							style="display: block;">
							{{'errors.required' | translate}}
						</div>
					</div>
					<ng-template [ngIf]="employee.isPrivate">
						<!-- rateo -->
						<div class="form-group col-md-4">
							<label>{{'employee.rateo' | translate}}*</label>
							<input
								type="number"
								class="form-control"
								name="rateo"
								[(ngModel)]="employee.rateo"
								required
								#rateo="ngModel"
								[ngClass]="{'is-invalid': editForm.submitted && rateo.invalid}">
							<div
								class="invalid-feedback"
								*ngIf="editForm.submitted && rateo.invalid">
								{{'errors.required' | translate}}
							</div>
						</div>
						<!-- contracthour -->
						<div class="form-group col-md-4">
							<label>
								<span>
									{{'employee.contracthour' | translate}}*
								</span>
								<i
									class="feather icon-help-circle"
									ngbTooltip="{{'employee.contracthour-help' | translate}}"></i>
							</label>
							<input
								type="number"
								class="form-control"
								name="contracthour"
								[(ngModel)]="employee.contracthour"
								required
								#contracthour="ngModel"
								[ngClass]="{'is-invalid': editForm.submitted && contracthour.invalid}">
							<div
								class="invalid-feedback"
								*ngIf="editForm.submitted && contracthour.invalid">
								{{'errors.required' | translate}}
							</div>
						</div>
						<!-- contractleave -->
						<div class="form-group col-md-4">
							<label>
								<span>
									{{'employee.contractleave' | translate}}*
								</span>
								<i
									class="feather icon-help-circle"
									ngbTooltip="{{'employee.contractleave-help' | translate}}"></i>

							</label>
							<input
								type="number"
								class="form-control"
								name="contractleave"
								[(ngModel)]="employee.contractleave"
								required
								#contractleave="ngModel"
								[ngClass]="{'is-invalid': editForm.submitted && contractleave.invalid}">
							<div
								class="invalid-feedback"
								*ngIf="editForm.submitted && contractleave.invalid">
								{{'errors.required' | translate}}
							</div>
						</div>
						<!-- inps -->
						<div class="form-group col-md-4">
							<label>{{'employee.inps' | translate}}*</label>
							<input
								type="number"
								class="form-control"
								name="inps"
								[(ngModel)]="employee.inps"
								required
								#inps="ngModel"
								[ngClass]="{'is-invalid': editForm.submitted && inps.invalid}">
							<div
								class="invalid-feedback"
								*ngIf="editForm.submitted && inps.invalid">
								{{'errors.required' | translate}}
							</div>
						</div>
						<!-- inail -->
						<div class="form-group col-md-4">
							<label>{{'employee.inail' | translate}}*</label>
							<input
								type="number"
								class="form-control"
								name="inail"
								[(ngModel)]="employee.inail"
								required
								#inail="ngModel"
								[ngClass]="{'is-invalid': editForm.submitted && inail.invalid}">
							<div
								class="invalid-feedback"
								*ngIf="editForm.submitted && inail.invalid">
								{{'errors.required' | translate}}
							</div>
						</div>
						<!-- basesalary -->
						<div class="form-group col-md-4">
							<label>{{'employee.basesalary' | translate}}*</label>
							<input
								type="number"
								class="form-control"
								name="basesalary"
								[(ngModel)]="employee.basesalary"
								required
								#basesalary="ngModel"
								[ngClass]="{'is-invalid': editForm.submitted && basesalary.invalid}">
							<div
								class="invalid-feedback"
								*ngIf="editForm.submitted && basesalary.invalid">
								{{'errors.required' | translate}}
							</div>
						</div>
					</ng-template>
					<ng-template [ngIf]="employee.isPublic">
						<!-- payurl -->
						<div class="form-group col-md-4">
							<label>{{ 'employee.payurl' | translate }}*</label>
							<input
								[(ngModel)]="employee.payurl"
								#payurl="ngModel"
								name="payurl"
								required
								type="text"
								class="form-control"
								id="payurl"
								placeholder="{{ 'employee.payurl' | translate }}"
								[ngClass]="{'is-invalid': editForm.submitted && payurl.invalid}">
							<div
								class="invalid-feedback"
								*ngIf="editForm.submitted && payurl.invalid">
								{{'errors.required' | translate}}
							</div>
						</div>
						<!-- yearlyhour -->
						<div class="form-group col-md-4">
							<label>{{'employee.yearlyhour' | translate}}*</label>
							<input
								type="number"
								class="form-control"
								name="yearlyhour"
								[(ngModel)]="employee.yearlyhour"
								required
								#yearlyhour="ngModel"
								[ngClass]="{'is-invalid': editForm.submitted && yearlyhour.invalid}">
							<div
								class="invalid-feedback"
								*ngIf="editForm.submitted && yearlyhour.invalid">
								{{'errors.required' | translate}}
							</div>
						</div>
						<!-- yearlysalary -->
						<div class="form-group col-md-4">
							<label>
								{{'employee.yearlysalary' | translate}}*
							</label>
							<input
								type="number"
								class="form-control"
								name="yearlysalary"
								[(ngModel)]="employee.yearlysalary"
								required
								#yearlysalary="ngModel"
								[ngClass]="{'is-invalid': editForm.submitted && yearlysalary.invalid}">
							<div
								class="invalid-feedback"
								*ngIf="editForm.submitted && yearlysalary.invalid">
								{{'errors.required' | translate}}
							</div>
						</div>
						<!-- oneri -->
						<div class="form-group col-md-4">
							<label>{{'employee.oneri' | translate}}*</label>
							<input
								type="number"
								class="form-control"
								name="oneri"
								[(ngModel)]="employee.oneri"
								required
								#oneri="ngModel"
								[ngClass]="{'is-invalid': editForm.submitted && oneri.invalid}">
							<div
								class="invalid-feedback"
								*ngIf="editForm.submitted && oneri.invalid">
								{{'errors.required' | translate}}
							</div>
						</div>
					</ng-template>
				</div>

			</div>
		</div>
	</div>

	<div class="modal-footer">

		<button
			type="reset"
			class="btn btn-secondary">
			{{'labels.reset' | translate}}
		</button>
		<button
			type="button"
			class="btn btn-secondary"
			(click)="dismiss()">
			{{'labels.cancel' | translate}}
		</button>
		<button
			type="submit"
			class="btn btn-primary">
			{{'labels.save' | translate}}
		</button>
	</div>

</form>
